import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { useDragLayer } from 'react-dnd';

const CardDragLayer = () => {
  const { isTabletSM } = useScreenSize();
  const { currentOffset, isDragging, item } = useDragLayer((monitor) => ({
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
  }));

  if (!isDragging || !currentOffset || !isMobile) {
    return null;
  }

  const style = {
    left: '-50px',
    maxWidth: '50%',
    pointerEvents: 'none',
    position: 'fixed',
    top: '-50px',
    transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
    zIndex: 1000,
  };

  return (
    <Flex
      alignItems="center"
      backgroundColor={theme.colors.hunterGreen[90]}
      borderColor={theme.colors.whiteLine[20]}
      borderStyle="solid"
      borderWidth={1}
      flex={1}
      justifyContent="center"
      minHeight={111}
      opacity={0.2}
      px={isTabletSM ? '8px' : 24}
      py={isTabletSM ? 16 : 24}
      style={style}
    >
      <Typography
        color={theme.colors.white[100]}
        textAlign="center"
        variant={isTabletSM ? 'MS-regular-s16-lh25' : 'MS-semibold-s18-lh27'}
      >
        {item?.text}
      </Typography>
    </Flex>
  );
};

export default CardDragLayer;
